var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 23.3846 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49026 31.06C8.87966 30.4333 8.57436 29.68 8.57436 28.8H14.8103C14.8103 29.68 14.505 30.4333 13.8944 31.06C13.2838 31.6867 12.5497 32 11.6923 32C10.8349 32 10.1009 31.6867 9.49026 31.06ZM5.45641 27.2V24H17.9282V27.2H5.45641ZM5.84615 22.4C4.05333 21.3067 2.63077 19.84 1.57846 18C0.526154 16.16 0 14.16 0 12C0 8.66667 1.13675 5.83333 3.41026 3.5C5.68376 1.16667 8.44444 0 11.6923 0C14.9402 0 17.7009 1.16667 19.9744 3.5C22.2479 5.83333 23.3846 8.66667 23.3846 12C23.3846 14.16 22.8585 16.16 21.8062 18C20.7538 19.84 19.3313 21.3067 17.5385 22.4H5.84615ZM6.78154 19.2H16.6031C17.7723 18.3467 18.6752 17.2933 19.3118 16.04C19.9484 14.7867 20.2667 13.44 20.2667 12C20.2667 9.54667 19.4352 7.46667 17.7723 5.76C16.1094 4.05333 14.0827 3.2 11.6923 3.2C9.30188 3.2 7.27521 4.05333 5.61231 5.76C3.9494 7.46667 3.11795 9.54667 3.11795 12C3.11795 13.44 3.43624 14.7867 4.07282 16.04C4.7094 17.2933 5.61231 18.3467 6.78154 19.2Z",
    fill: "url(#acorisLightbulbGradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49026 31.06C8.87966 30.4333 8.57436 29.68 8.57436 28.8H14.8103C14.8103 29.68 14.505 30.4333 13.8944 31.06C13.2838 31.6867 12.5497 32 11.6923 32C10.8349 32 10.1009 31.6867 9.49026 31.06ZM5.45641 27.2V24H17.9282V27.2H5.45641Z",
    fill: "#119ED9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "acorisLightbulbGradient",
    x1: -0.142077,
    y1: 1.39374,
    x2: 28.8139,
    y2: 8.55326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FABC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D10A11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.cc9bb8689edc8efea4a8ae8483e248e4.svg";
export { ForwardRef as ReactComponent };